<div class="row col-12 justify-content-md-center">
	<form (ngSubmit)="reverseRT()" class="col-md-6 col-sm-12" validate-form="reverseRT">
		<h2>{{'action_log.reverse_rt' | translate}}</h2>
		<div *ngIf="isIMDevice" class="mb-3">
			<p class="mb-1">{{'admin.reverse_rt_description' | translate}}</p>
			<ul>
				<li>{{'rt.active_power_consumed' | translate}} &lt;--&gt; {{'rt.active_power_generated' | translate}}</li>
				<li>{{'rt.va_t_kva_consumed' | translate}} &lt;--&gt; {{'rt.va_t_kva_generated' | translate}}</li>
				<li>{{'rt.var_t_kvar_consumed' | translate}} &lt;--&gt; {{'rt.var_t_kvar_generated' | translate}}</li>
				<li>{{'rt.watt_hr_t_kwh_consumed' | translate}} &lt;--&gt; {{'rt.watt_hr_t_kwh_generated' | translate}}</li>
			</ul>
		</div>
		<div class="form-field mb-2">
			<label for="start_id">{{'g.start_id' | translate}}</label>
			<input type="number" class="form-control" name="start_id" [(ngModel)]="startId"/>
		</div>
		<div class="form-field mb-2">
			<label for="end_id">{{'g.end_id' | translate}}</label>
			<input type="number" class="form-control" name="end_id" [(ngModel)]="endId"/>
		</div>
		<div class="my-4">
			<button type="submit" class="btn btn-primary" [disabled]="startId > endId">{{'g.reverse_rt' | translate}}</button>
		</div>
	</form>
</div>